var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from '../../decorators/injectable';
import { stateable } from '../../decorators/stateable';
/** The name of the module */
export const name = 'TargetStrategy';
/** Default Options of the Options Interface */
const defaultOptions = {
    defaultVisibility: false,
    enableVisibilityToggling: true,
};
let TargetStrategy = class TargetStrategy {
    /**
     * Create a Target Strategy
     *
     * @param {Options} Object Data to initialize the component with
     */
    constructor(options) {
        // If options.elements is a single element, turn it into an array. Otherwise, just assign array to this.elements
        this.elements = options.elements instanceof HTMLElement ? [options.elements] : options.elements;
        this.classNames = options.classNames;
        this.defaultVisibility = options.defaultVisibility ?? defaultOptions.defaultVisibility;
        this.enableVisibilityToggling = options.enableVisibilityToggling ?? defaultOptions.enableVisibilityToggling;
        this.init();
    }
    /**
     * Initializes the module
     */
    init() {
        // Initialize the state
        const initialState = {
            isVisible: this.defaultVisibility,
        };
        this.initState(initialState);
        // Adds the default visible toggle class name on each element which will hide the element
        if (this.classNames.base) {
            this.elements.forEach((element) => {
                element.classList.add(this.classNames.base);
            });
        }
        // If the visible state is true, add the visible class name onto it (only applicable on init)
        if (this.getState().isVisible) {
            this.elements.forEach((element) => {
                element.classList.add(this.classNames.visible);
            });
        }
    }
    /**
     * Toggles the visibilityState for this module
     */
    toggleVisibility() {
        if (!this.enableVisibilityToggling) {
            return;
        }
        this.setState({
            isVisible: !this.getState().isVisible,
        });
        this.elements.forEach((element) => {
            // Adds class toggling for each element based on state
            element.classList.toggle(this.classNames.visible, this.getState().isVisible);
        });
    }
    /**
     * Gets the current state of the target
     */
    getVisibilityState() {
        const { isVisible } = this.getState();
        return isVisible;
    }
};
TargetStrategy = __decorate([
    stateable(name),
    injectable(name)
], TargetStrategy);
export default TargetStrategy;
